var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccessibility = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B",
  d: "M31 16.6h-7.3v15.9h-2.4v-7.3h-2.4v7.3h-2.6V16.6H9v-2.5h22zM20 8c1.4 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4-2.4-1-2.4-2.4S18.6 8 20 8Z"
})));
export default SvgAccessibility;